// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"style_bgImg__swdKP"};